<template>
  <div id="stamp-verification" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Stamp Verification</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="verifyLoanStampData()" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout class="m-t-15">
        <v-flex>
          <label class="px-1 my-2 header">
            Personal
          </label>
          <v-btn
            icon
            color="red"
            x-small
            v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.DISPLAY_DECLINE_ICON_IN_RIGHT_PANEL, dataType.PrivilegeType.EXECUTABLE) && isShowDeclineIcon()"
            @click="showDeclineStampDialog(declineStampInfo.personalStamp)"
          >
            <v-icon>notification_important</v-icon>
          </v-btn>
          <v-layout class="m-l-30" wrap>
            <v-flex lg2 class="field-name">Type</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.personalStamp.stampType }}</v-flex>
            <v-flex lg2 class="field-name">Reason</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.personalStamp.stampReason }}</v-flex>
            <v-flex lg2 class="field-name">Stamped By</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.personalStamp.stampedBy }}</v-flex>
            <v-flex lg2 class="field-name">Stamped At</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.personalStamp.stampedAt }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="m-t-15">
        <v-flex>
          <label class="px-1 my-2 header">
            Employment
          </label>
          <v-btn
            icon
            color="red"
            x-small
            v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.DISPLAY_DECLINE_ICON_IN_RIGHT_PANEL, dataType.PrivilegeType.EXECUTABLE) && isShowDeclineIcon()"
            @click="showDeclineStampDialog(declineStampInfo.employmentStamp)"
          >
            <v-icon>notification_important</v-icon>
          </v-btn>
          <v-layout class="m-l-30" wrap>
            <v-flex lg2 class="field-name">Type</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.employmentStamp.stampType }}</v-flex>
            <v-flex lg2 class="field-name">Reason</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.employmentStamp.stampReason }}</v-flex>
            <v-flex lg2 class="field-name">Stamped By</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.employmentStamp.stampedBy }}</v-flex>
            <v-flex lg2 class="field-name">Stamped At</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.employmentStamp.stampedAt }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="m-t-15">
        <v-flex>
          <label class="px-1 my-2 header">
            Banking
          </label>
          <v-btn
            icon
            color="red"
            x-small
            v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.DISPLAY_DECLINE_ICON_IN_RIGHT_PANEL, dataType.PrivilegeType.EXECUTABLE) && isShowDeclineIcon()"
            @click="showDeclineStampDialog(declineStampInfo.bankingStamp)"
          >
            <v-icon>notification_important</v-icon>
          </v-btn>
          <v-layout class="m-l-30" wrap>
            <template v-for="(item, index) of stampInfo.bankingStamp">
              <v-flex lg2 class="field-name" :key="assist.tool.getRandomKey(index)">Type</v-flex>
              <v-flex lg3 class="field-value" :key="assist.tool.getRandomKey(index)">{{ item.stampType }}</v-flex>
              <v-flex lg2 class="field-name" :key="assist.tool.getRandomKey(index)">Reason</v-flex>
              <v-flex lg5 class="field-value" :key="assist.tool.getRandomKey(index)">{{ item.stampReason }}</v-flex>
              <v-flex lg2 class="field-name" :key="assist.tool.getRandomKey(index)">Stamped By</v-flex>
              <v-flex lg3 class="field-value" :key="assist.tool.getRandomKey(index)">{{ item.stampedBy }}</v-flex>
              <v-flex lg2 class="field-name" :key="assist.tool.getRandomKey(index)">Stamped At</v-flex>
              <v-flex lg5 class="field-value" :key="assist.tool.getRandomKey(index)">{{ item.stampedAt }}</v-flex>
              <v-divider :key="assist.tool.getRandomKey(index)" class="m-b-30"></v-divider>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="m-t-15">
        <v-flex>
          <label class="px-1 my-2 header">
            Payment Plan Options
          </label>
          <v-btn
            icon
            color="red"
            x-small
            v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.DISPLAY_DECLINE_ICON_IN_RIGHT_PANEL, dataType.PrivilegeType.EXECUTABLE) && isShowDeclineIcon()"
            @click="showDeclineStampDialog(declineStampInfo.paymentOptionStamp)"
          >
            <v-icon>notification_important</v-icon>
          </v-btn>
          <v-layout class="m-l-30" wrap>
            <v-flex lg2 class="field-name">Type</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.paymentOptionStamp.stampType }}</v-flex>
            <v-flex lg2 class="field-name">Reason</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.paymentOptionStamp.stampReason }}</v-flex>
            <v-flex lg2 class="field-name">Stamped By</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.paymentOptionStamp.stampedBy }}</v-flex>
            <v-flex lg2 class="field-name">Stamped At</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.paymentOptionStamp.stampedAt }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="m-t-15">
        <v-flex>
          <label class="px-1 my-2 header">
            Document
          </label>
          <v-layout class="m-l-30" wrap>
            <v-flex lg2 class="field-name">Type</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.documentStamp.stampType }}</v-flex>
            <v-flex lg2 class="field-name">Reason</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.documentStamp.stampReason }}</v-flex>
            <v-flex lg2 class="field-name">Stamped By</v-flex>
            <v-flex lg3 class="field-value">{{ stampInfo.documentStamp.stampedBy }}</v-flex>
            <v-flex lg2 class="field-name">Stamped At</v-flex>
            <v-flex lg5 class="field-value">{{ stampInfo.documentStamp.stampedAt }}</v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="declineDialog" max-width="30%" persistent
      >
        <v-card>
          <v-card-title>
            Decline Stamp
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-textarea
              placeholder="Do you want to decline stamp"
              outlined
              v-model="notes"
              hide-details
              class="show-choosed-item"
              rows="5"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="saveDeclineStampNotes(declineData)"
            >OK</v-btn>
            <v-btn
              text
              @click="declineDialog = false"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { Tool, DataType, Popup, Authentication } from '@/util'
import { OriginationApi, OriginationBusinessApi } from '@/api/pandaria'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'stamp-verification',
  props: {
    loan: Object,
    authorization: Object
  },
  data () {
    return {
      themeColor: 'lightBlue',
      themeRGB: '(3, 169, 244, 0.1)',
      sideBarOption: 'light',
      fontType: 'Montserrat',
      dataType: DataType,
      stampInfo: {
        personalStamp: {
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        },
        employmentStamp: {
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        },
        bankingStamp: [{
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        }, {
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        }],
        paymentOptionStamp: {
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        },
        documentStamp: {
          stampedAt: 'N/A',
          stampedBy: 'N/A',
          stampReason: 'N/A',
          stampType: 'N/A'
        }
      },
      assist: {
        tool: tool
      },
      verificationData: {
        bankingStamp: [],
        employmentStamp: {},
        paymentOptionStamp: {},
        personalStamp: {},
        documentStamp: {}
      },
      declineDialog: false,
      notes: '',
      declineStampInfo: {
        personalStamp: {
          sectionKey: DataType.LoanSectionKey.PERSONAL,
          code: DataType.StampReasonEnum.PERSONAL_DECLINE.value,
          type: DataType.StampReasonEnum.PERSONAL_DECLINE.type
        },
        employmentStamp: {
          sectionKey: DataType.LoanSectionKey.EMPLOYMENT,
          code: DataType.StampReasonEnum.EMPLOYMENT_DECLINE.value,
          type: DataType.StampReasonEnum.EMPLOYMENT_DECLINE.type
        },
        bankingStamp: {
          sectionKey: DataType.LoanSectionKey.BANKING,
          code: DataType.StampReasonEnum.BANKING_DECLINE.value,
          type: DataType.StampReasonEnum.BANKING_DECLINE.type
        },
        paymentOptionStamp: {
          sectionKey: DataType.LoanSectionKey.PAYMENT_OPTION,
          code: DataType.StampReasonEnum.PAYMENT_DECLINE.value,
          type: DataType.StampReasonEnum.PAYMENT_DECLINE.type
        }
      },
      declineData: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  mounted () {
    this.$eventBus.$on('calculateScore', (target) => {
      const stampKey = target.stampKey
      this.verificationData[stampKey] = target.stamp
      this.initStampVerification()
    })
  },
  watch: {
    loanId (newVal) {
      this.assist.tool.isNotEmpty(newVal) && this.initStampVerification()
      this.verifyLoanStampData()
    }
  },
  methods: {
    verifyLoanStampData () {
      const $this = this
      if (tool.isNotEmpty(this.loanId)) {
        const verifyData = {
          loanId: this.loanId
        }
        OriginationBusinessApi.verifyLoanStamp(verifyData, function (result) {
          $this.verificationData = $this.conventStampData(JSON.parse(JSON.stringify(result)))
          $this.initStampVerification()
          if (tool.isNotEmpty(result)) {
            for (const key in result) {
              const item = result[key]
              if (item.sectionKey === 'personal') {
                $this.$store.commit('setPersonalRemote', item)
              }
            }
          }
        })
      }
    },
    conventStampData (stampData) {
      const currentStamp = {
        bankingStamp: [],
        employmentStamp: {},
        paymentOptionStamp: {},
        personalStamp: {},
        documentStamp: {}
      }
      const tool = this.assist.tool
      if (tool.isNotEmpty(stampData)) {
        currentStamp.personalStamp = tool.isNotEmpty(stampData.personalStamp) ? stampData.personalStamp : {}
        currentStamp.employmentStamp = tool.isNotEmpty(stampData.employmentStamp) ? stampData.employmentStamp : {}
        currentStamp.bankingStamp = tool.isNotEmpty(stampData.bankingStamp) ? stampData.bankingStamp : []
        currentStamp.paymentOptionStamp = tool.isNotEmpty(stampData.paymentOptionStamp) ? stampData.paymentOptionStamp : {}
        currentStamp.documentStamp = tool.isNotEmpty(stampData.documentStamp) ? stampData.documentStamp : {}
      }
      return currentStamp
    },
    initStampVerification () {
      const verificationData = this.verificationData
      if (this.assist.tool.isEmpty(verificationData)) {
        return
      }
      for (const stampSectionKey in verificationData) {
        const sectionStampData = verificationData[stampSectionKey]
        if (stampSectionKey === 'bankingStamp') {
          for (let i = 0; i < sectionStampData.length; i++) {
            this.convertStampData(sectionStampData[i], this.stampInfo.bankingStamp[i])
          }
        } else {
          this.convertStampData(sectionStampData, this.stampInfo[stampSectionKey])
        }
      }
      this.$forceUpdate()
    },
    getFullName (item) {
      if (tool.isNotEmpty(item)) {
        const it = JSON.parse(item)
        this.assist.tool.getFullName()
        return `${it.firstName} ${it.middleName} ${it.lastName}`
      }
      return ''
    },
    convertStampData (stampData, convertedStampData) {
      const tool = this.assist.tool
      convertedStampData.stampedBy = tool.isNotEmpty(stampData.stampedBy) ? tool.getFullName(stampData.stampedBy) : 'N/A'
      convertedStampData.stampedAt = tool.isNotEmpty(stampData.stampedAt) ? tool.formatDateTime(stampData.stampedAt) : 'N/A'
      convertedStampData.stampType = tool.isNotEmpty(tool.getEnumTextByValue(DataType.StampActionTypeEnum, stampData.type)) ? tool.getEnumTextByValue(DataType.StampActionTypeEnum, stampData.type) : 'N/A'
      convertedStampData.stampReason = tool.isNotEmpty(tool.getEnumTextByValue(DataType.StampReasonEnum, stampData.code)) ? tool.getEnumTextByValue(DataType.StampReasonEnum, stampData.code) : 'N/A'
    },
    checkPropertyValue (data, key) {
      return Object.prototype.hasOwnProperty.call(data, key)
    },
    /*
    Decline stamp dialog
    **/
    showDeclineStampDialog (data) {
      this.declineData = data
      this.declineDialog = true
    },
    saveDeclineStampNotes (data) {
      const $this = this
      const saveStampData = {
        loanId: $this.loan.id,
        feature: 'STAMP',
        featureData: {
          sectionKey: data.sectionKey,
          type: data.type,
          code: data.code,
          notes: $this.notes
        }
      }
      OriginationApi.addSectionFeature(saveStampData, function () {
        $this.$emit('changeLightIconType', data.type)
        $this.$eventBus.$emit('updateStamp', data.sectionKey)
        popup.popupForSuccess('Operate successfully')
      }, function (result) {
        popup.popupForError(result)
      })
      this.declineDialog = false
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    isShowDeclineIcon () {
      const loanOperation = this.$store.getters.getLoanOperation
      if (tool.isEmpty(loanOperation) || tool.isEmpty(loanOperation.auditedId)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style>
#stamp-verification .flex {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss" scoped>
.header {
  font-size: 18px;
  font-weight: 400;
}
.toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
